// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* DataIdModal.module.css */
.DataIdModal_data-ids-container__Gxm0E {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 5px;
}

.DataIdModal_data-ids-button__J9QYj {
  background: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 2px 10px;
  font-size: 12px;
  font-family: monospace;
  color: #495057;
  cursor: pointer;
  transition: all 0.2s ease;
}

.DataIdModal_data-ids-button__J9QYj:hover {
  background: #007bff;
  color: white;
  border-color: #007bff;
}

/* Modal styles */
.DataIdModal_modal-overlay__AeSbf {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.DataIdModal_modal__--\\+n2 {
  background: white;
  border-radius: 12px;
  max-width: 800px;
  width: 90%;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.DataIdModal_modal-header__ZeaN4 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.DataIdModal_modal-header__ZeaN4 h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.DataIdModal_close-button__ZxPmk {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #6c757d;
  padding: 0 8px;
}

.DataIdModal_close-button__ZxPmk:hover {
  color: #1f2937;
}

.DataIdModal_modal-content__uZ-uP {
  padding: 24px;
  overflow-y: auto;
  flex: 1 1;
}

.DataIdModal_loading__Zz133 {
  text-align: center;
  padding: 40px;
  color: #6c757d;
}

.DataIdModal_error__rnDdY {
  color: #dc3545;
  padding: 12px;
  background: #f8d7da;
  border-radius: 6px;
  border: 1px solid #f5c6cb;
}

.DataIdModal_document-item__EBo7- {
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.DataIdModal_document-info__FiscJ {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.DataIdModal_info-row__5-436 {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.DataIdModal_info-row__5-436 strong {
  font-size: 13px;
  color: #495057;
}

.DataIdModal_info-value__M42vo {
  font-size: 14px;
  color: #1f2937;
  word-break: break-all;
}

.DataIdModal_data-content__22Lwb {
  font-size: 14px;
  color: #1f2937;
  background: white;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 300px;
  overflow-y: auto;
  line-height: 1.6;
}

.DataIdModal_no-data__cj7Fs {
  text-align: center;
  padding: 40px;
  color: #6c757d;
}

.DataIdModal_document-error__ItrbY {
  color: #dc3545;
  padding: 8px 12px;
  background: #f8d7da;
  border-radius: 4px;
}

/* DataIdModal.module.css */
.DataIdModal_modal-overlay__AeSbf {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.DataIdModal_modal__--\\+n2 {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.DataIdModal_modal-header__ZeaN4 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f8f9fa;
}

.DataIdModal_modal-header__ZeaN4 h3 {
  margin: 0;
  color: #333;
}

.DataIdModal_close-button__ZxPmk {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.DataIdModal_close-button__ZxPmk:hover {
  background-color: #e0e0e0;
  color: #333;
}

.DataIdModal_modal-content__uZ-uP {
  padding: 20px;
  overflow-y: auto;
  max-height: calc(90vh - 80px);
}

.DataIdModal_loading__Zz133,
.DataIdModal_error__rnDdY,
.DataIdModal_no-data__cj7Fs {
  text-align: center;
  padding: 40px 20px;
  color: #666;
}

.DataIdModal_error__rnDdY {
  color: #dc3545;
}

.DataIdModal_documents-list__e-017 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.DataIdModal_document-item__EBo7- {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 20px;
  background-color: #fafafa;
}

.DataIdModal_document-id__KsXBS {
  margin-top: 0;
  margin-bottom: 15px;
  color: #333;
  font-size: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
}

.DataIdModal_document-info__FiscJ {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.DataIdModal_info-row__5-436 {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.DataIdModal_info-row__5-436 strong {
  color: #555;
  font-size: 14px;
  margin-bottom: 3px;
}

.DataIdModal_info-value__M42vo {
  color: #007bff;
  font-family: monospace;
  font-size: 14px;
  word-break: break-all;
  padding: 8px 12px;
  background-color: #e9ecef;
  border-radius: 4px;
}

.DataIdModal_data-content__22Lwb {
  color: #333;
  font-family: monospace;
  font-size: 14px;
  white-space: pre-wrap;
  word-break: break-word;
  padding: 12px;
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  line-height: 1.4;
}

.DataIdModal_document-error__ItrbY {
  color: #dc3545;
  padding: 10px;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  font-size: 14px;
}

.DataIdModal_document-loading__ZAJVe {
  color: #666;
  text-align: center;
  padding: 20px;
}

/* Data IDs Button Styles */
.DataIdModal_data-ids-button__J9QYj {
  margin-left: 12px;
  padding: 4px 8px;
  background: #e3f2fd;
  border: 1px solid #1976d2;
  border-radius: 12px;
  font-size: 0.8em;
  color: #1976d2;
  font-family: monospace;
  cursor: pointer;
  transition: all 0.2s ease;
}

.DataIdModal_data-ids-button__J9QYj:hover {
  background: #bbdefb;
  transform: translateY(-1px);
}

.DataIdModal_data-ids-button__J9QYj:active {
  transform: translateY(0);
}
`, "",{"version":3,"sources":["webpack://./src/Component/app_components/DataIdModal.module.css"],"names":[],"mappings":";AACA,2BAA2B;AAC3B;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;;EAGE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["\n/* DataIdModal.module.css */\n.data-ids-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 5px;\n}\n\n.data-ids-button {\n  background: #e9ecef;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  padding: 2px 10px;\n  font-size: 12px;\n  font-family: monospace;\n  color: #495057;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.data-ids-button:hover {\n  background: #007bff;\n  color: white;\n  border-color: #007bff;\n}\n\n/* Modal styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10000;\n}\n\n.modal {\n  background: white;\n  border-radius: 12px;\n  max-width: 800px;\n  width: 90%;\n  max-height: 85vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #6c757d;\n  padding: 0 8px;\n}\n\n.close-button:hover {\n  color: #1f2937;\n}\n\n.modal-content {\n  padding: 24px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #6c757d;\n}\n\n.error {\n  color: #dc3545;\n  padding: 12px;\n  background: #f8d7da;\n  border-radius: 6px;\n  border: 1px solid #f5c6cb;\n}\n\n.document-item {\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.document-info {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.info-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.info-row strong {\n  font-size: 13px;\n  color: #495057;\n}\n\n.info-value {\n  font-size: 14px;\n  color: #1f2937;\n  word-break: break-all;\n}\n\n.data-content {\n  font-size: 14px;\n  color: #1f2937;\n  background: white;\n  padding: 12px;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n  white-space: pre-wrap;\n  word-break: break-word;\n  max-height: 300px;\n  overflow-y: auto;\n  line-height: 1.6;\n}\n\n.no-data {\n  text-align: center;\n  padding: 40px;\n  color: #6c757d;\n}\n\n.document-error {\n  color: #dc3545;\n  padding: 8px 12px;\n  background: #f8d7da;\n  border-radius: 4px;\n}\n\n/* DataIdModal.module.css */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: white;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 800px;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #e0e0e0;\n  background-color: #f8f9fa;\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: #333;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n.close-button:hover {\n  background-color: #e0e0e0;\n  color: #333;\n}\n\n.modal-content {\n  padding: 20px;\n  overflow-y: auto;\n  max-height: calc(90vh - 80px);\n}\n\n.loading,\n.error,\n.no-data {\n  text-align: center;\n  padding: 40px 20px;\n  color: #666;\n}\n\n.error {\n  color: #dc3545;\n}\n\n.documents-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.document-item {\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  padding: 20px;\n  background-color: #fafafa;\n}\n\n.document-id {\n  margin-top: 0;\n  margin-bottom: 15px;\n  color: #333;\n  font-size: 16px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.document-info {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.info-row {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.info-row strong {\n  color: #555;\n  font-size: 14px;\n  margin-bottom: 3px;\n}\n\n.info-value {\n  color: #007bff;\n  font-family: monospace;\n  font-size: 14px;\n  word-break: break-all;\n  padding: 8px 12px;\n  background-color: #e9ecef;\n  border-radius: 4px;\n}\n\n.data-content {\n  color: #333;\n  font-family: monospace;\n  font-size: 14px;\n  white-space: pre-wrap;\n  word-break: break-word;\n  padding: 12px;\n  background-color: #f8f9fa;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  max-height: 200px;\n  overflow-y: auto;\n  line-height: 1.4;\n}\n\n.document-error {\n  color: #dc3545;\n  padding: 10px;\n  background-color: #f8d7da;\n  border: 1px solid #f5c6cb;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.document-loading {\n  color: #666;\n  text-align: center;\n  padding: 20px;\n}\n\n/* Data IDs Button Styles */\n.data-ids-button {\n  margin-left: 12px;\n  padding: 4px 8px;\n  background: #e3f2fd;\n  border: 1px solid #1976d2;\n  border-radius: 12px;\n  font-size: 0.8em;\n  color: #1976d2;\n  font-family: monospace;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.data-ids-button:hover {\n  background: #bbdefb;\n  transform: translateY(-1px);\n}\n\n.data-ids-button:active {\n  transform: translateY(0);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"data-ids-container": `DataIdModal_data-ids-container__Gxm0E`,
	"data-ids-button": `DataIdModal_data-ids-button__J9QYj`,
	"modal-overlay": `DataIdModal_modal-overlay__AeSbf`,
	"modal": `DataIdModal_modal__--+n2`,
	"modal-header": `DataIdModal_modal-header__ZeaN4`,
	"close-button": `DataIdModal_close-button__ZxPmk`,
	"modal-content": `DataIdModal_modal-content__uZ-uP`,
	"loading": `DataIdModal_loading__Zz133`,
	"error": `DataIdModal_error__rnDdY`,
	"document-item": `DataIdModal_document-item__EBo7-`,
	"document-info": `DataIdModal_document-info__FiscJ`,
	"info-row": `DataIdModal_info-row__5-436`,
	"info-value": `DataIdModal_info-value__M42vo`,
	"data-content": `DataIdModal_data-content__22Lwb`,
	"no-data": `DataIdModal_no-data__cj7Fs`,
	"document-error": `DataIdModal_document-error__ItrbY`,
	"documents-list": `DataIdModal_documents-list__e-017`,
	"document-id": `DataIdModal_document-id__KsXBS`,
	"document-loading": `DataIdModal_document-loading__ZAJVe`
};
export default ___CSS_LOADER_EXPORT___;
